import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SIDE_NAV_CONFIGURATOR } from '@montebravo.tech/design-system-navigation';
import { AppShellService } from './app-shell.service';

@Component({
    selector: 'app-shell',
    templateUrl: './app-shell.component.html',
    styleUrls: ['./app-shell.component.scss'],
    providers: [
        {
            provide: SIDE_NAV_CONFIGURATOR,
            useClass: AppShellService,
        },
    ],
    encapsulation: ViewEncapsulation.None,
})
export class AppShellComponent implements OnInit {
    srcLogo = {
        lg: '../../../assets/img/menu/logo-lg.svg',
        sm: '../../../assets/img/menu/logo-sm.svg',
    };

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private service: AppShellService
    ) {}

    ngOnInit(): void {
        if (this.route.children.length === 0) {
            const firstNavLink = this.service.getNavLinksSync()[0];
            if (firstNavLink) {
                this.router.navigateByUrl(firstNavLink.link);
            } else {
                alert(
                    'Usuário sem função associada, entre em contato com o suporte.'
                );
                localStorage.clear();
                this.router.navigateByUrl('/');
            }
        }
    }
}
